import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromNavigationState from './navigation-state.reducer';

export const selectNavigationStateState =
  createFeatureSelector<fromNavigationState.State>(
    fromNavigationState.navigationStateFeatureKey
  );

export const selectNavigationHasSubmenu = createSelector(
  selectNavigationStateState,
  (state) => state.hasSubmenu
);
export const selectNavigationShouldMobileMenuBeOpen = createSelector(
  selectNavigationStateState,
  (state) => state.mobileMenuOpenOpen
);
export const selectNavigationHasSave = createSelector(
  selectNavigationStateState,
  (state) => state.hasSave
);
export const selectHasMobileMenuDisabled = createSelector(
  selectNavigationStateState,
  (state) => state.disableMobileMenu
);
export const selectIsNavigationOpen = createSelector(
  selectNavigationStateState,
  (state) => state.isOpen
);
export const selectIsNavigationSubNavigationForcedToBeOpen = createSelector(
  selectNavigationStateState,
  (state) => state.forceSubNavigationOpen
);
